import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  API_TERMS,
  COOKIE_POLICY,
  FAQ,
  GAME_RULES,
  LEGAL_NOTICE,
  MARKETPLACE_TERMS,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
} from '@sorare/core/src/constants/__generated__/routes';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

const Root = styled.div`
  margin-bottom: var(--triple-unit);
`;

export const InfoLayout = ({ children }: PropsWithChildren) => {
  return (
    <AppLayout>
      <ContentWithStickyHeader
        header={
          <FullWidthContainer.NoPadding>
            <TabBar variant="flat" fullWidth>
              <Tab to={FAQ}>
                <FormattedMessage {...navLabels.faq} />
              </Tab>
              <Tab to={GAME_RULES}>
                <FormattedMessage {...navLabels.gameRules} />
              </Tab>
              <Tab to={TERMS_AND_CONDITIONS}>
                <FormattedMessage {...navLabels.terms} />
              </Tab>
              <Tab to={MARKETPLACE_TERMS}>
                <FormattedMessage {...navLabels.marketplaceTerms} />
              </Tab>
              <Tab to={API_TERMS}>
                <FormattedMessage {...navLabels.apiTerms} />
              </Tab>
              <Tab to={PRIVACY_POLICY}>
                <FormattedMessage {...navLabels.privacyPolicy} />
              </Tab>
              <Tab to={COOKIE_POLICY}>
                <FormattedMessage {...navLabels.cookiePolicy} />
              </Tab>

              <Tab to={LEGAL_NOTICE}>
                <FormattedMessage {...navLabels.legalNotice} />
              </Tab>
            </TabBar>
          </FullWidthContainer.NoPadding>
        }
      >
        <Root>
          <Container>{children}</Container>
        </Root>
      </ContentWithStickyHeader>
    </AppLayout>
  );
};
